/**
 * Custom File Upload
 * ------------------------------------------------------------------------------
 * This scripts base on an assumption that on DOM side there's
 * custom file upload button, and this is supposed to just output file name since original input field is(should be) being hidden.
 *
   * @namespace custom

	 * DOM example
	 <label class="custom-file-upload" for="Certificate">
		 <p class="btn btn--secondary">Choose File</p>
		 <span class="custom-file-upload__name">No File Chosen</span>
	 </label>
	 <input type="file" class="block w-full" name="customer[certificate]" id="Certificate" required>
	 *
 */
custom.FormFileUpload = (() => {
  const fileUploaderClassName = 'custom-file-upload';
  const fileNameClassName = 'custom-file-upload__name';
  const dropzoneClassName = 'custom-file-upload__dropzone';

  const $fileUploads = $(`.${fileUploaderClassName}`);

  function getFileName(filename = null) {
    return filename != ''
      ? filename.substring(filename.lastIndexOf('\\') + 1)
      : 'No File Chosen';
  }

  function replaceNameHandler(event = null) {
    const $target = $(event.target);
    const fileName = getFileName($target.val());

    $target
      .siblings(`.${fileUploaderClassName}`)
      .find(`.${fileNameClassName}`)
      .text(fileName);
  }

  function init() {
    if (!$fileUploads.length) return;

    $.each($fileUploads, (i, uploader) => {
      const fileInput = $(uploader).siblings('input[type="file"]');
      fileInput.on('change', replaceNameHandler);
      const dropzone = $(uploader).parent(`.${dropzoneClassName}`);
      if (dropzone) {
        // highlight drag area
        fileInput.on('dragenter focus click', function () {
          dropzone.addClass('is-active');
        });

        // back to normal state
        fileInput.on('dragleave blur drop', function () {
          dropzone.removeClass('is-active');
        });
      }
    });
  }

  return {
    init,
  };
})();

custom.FormFileUpload.init();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/form-file-upload.js